import { useState } from 'react';
import { useApp } from '../stores/app';

export function Login() {
  const login = useApp((s) => s.login);
  const [form, setForm] = useState({ login: '', password: '' });
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(form.login, form.password);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="panel login-card" onSubmit={submit}>
        <h2>Вход в админку рестримера</h2>
        <div className="field">
          <label htmlFor="login">Логин</label>
          <input
            id="login"
            autoComplete="username"
            value={form.login}
            onChange={(e) => setForm({ ...form, login: e.target.value })}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Пароль</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
        </div>
        {error && <p className="error-text">{error}</p>}
        <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
          {busy ? 'Проверяю…' : 'Войти'}
        </button>
        <p className="muted" style={{ fontSize: 12, marginBottom: 0 }}>
          Первый администратор создаётся из ADMIN_BOOTSTRAP_LOGIN и ADMIN_BOOTSTRAP_PASSWORD при первом запуске.
        </p>
      </form>
    </div>
  );
}
